module.exports = __webpack_public_path__ + "img/9788949120553.94a4be79.jpg";